import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { sortByDate } from '../../utils/commonutils';

const ProductionTableData = ({ reportData, detailsModal, eventClick, page, getPracticeName, forcedTotal }) => {
  const [column, setColumn] = useState(null);
  const [data, setData] = useState(reportData);
  const [order, setOrder] = useState(true);

  useEffect(() => {
    if (reportData.length && data.length && (reportData.length !== data.length || Object.keys(reportData[0]).length !== Object.keys(data[0]).length)) {
      let updateData = reportData;

      if (column) {
        updateData = _.sortBy(updateData, [column])
        if (!order) {
          updateData.reverse();
        }
      }
      setData(updateData);
    }
  }, [reportData, data.length, column, order]);

  const formatCurrency = (value) => {
    const floatValue = parseFloat(value)
    return ('$' + (floatValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')).replace('$-', '-$');
  }

  const handleSort = clickedColumn => () => {
    if (column !== clickedColumn) {
      setColumn(clickedColumn);
      setData(_.sortBy(data, [clickedColumn]));
      setOrder(true);
      return
    }

    setData([...data].reverse());
    setOrder(!order);
  }

  const trimString = (str, len, addDots) => {
    return (
      (str && str.length > len) ?
        (addDots !== false ?
          str.substring(0, len - 3) :
          str.substring(0, len - 3) + '...') :
        str);
  }

  const getHeader = (detailsModal, eventClick) => {
    const direction = order ? 'down' : 'up';
    if (detailsModal === 'report') {
      return (
        <tr>
          {
            page === 'bGoal' ?
              <th className={`cursorPointer ${column === 'drName' ? 'active' : ''}`} onClick={handleSort('drName')}>
                <div>
                  DrName
                  <i className={`sort amount ${direction} icon ml-05`}></i>
                </div>
              </th>
              :
              <th className={`cursorPointer ${column === 'practice' ? 'active' : ''}`} onClick={handleSort('practice')}>
                <div>
                  Practice
                  <i className={`sort amount ${direction} icon ml-05`}></i>
                </div>
              </th>
          }
          <th className={`cursorPointer ${column === 'patientId' ? 'active' : ''}`} onClick={handleSort('patientId')}>
            Patient#
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'price' ? 'active' : ''}`} onClick={handleSort('price')}>
            bCARE
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          {eventClick === 'month' && <th className={`cursorPointer ${column === 'dateOfService' ? 'active' : ''}`} onClick={handleSort('dateOfService')}>
            Date Of Service
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>}
        </tr>
      );
    } else {
      return (
        <tr>
          {
            page === 'bGoal' ?
              <th className={`cursorPointer ${column === 'drName' ? 'active' : ''}`} onClick={handleSort('drName')}>
                <div>
                  DrName
                  <i className={`sort amount ${direction} icon ml-05`}></i>
                </div>
              </th>
              :
              <th className={`cursorPointer ${column === 'practice' ? 'active' : ''}`} onClick={handleSort('practice')}>
                <div>
                  Practice
                  <i className={`sort amount ${direction} icon ml-05`}></i>
                </div>
              </th>
          }
          <th className={`cursorPointer ${column === 'patientId' ? 'active' : ''}`} onClick={handleSort('patientId')}>
            Patient#
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'age' ? 'active' : ''}`} onClick={handleSort('age')}>
            Age
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'insurance' ? 'active' : ''}`} onClick={handleSort('insurance')}>
            Insurance
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'procCode' ? 'active' : ''}`} onClick={handleSort('procCode')}>
            Proc Code
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'Next_Apt' ? 'active' : ''}`} onClick={handleSort('Next_Apt')}>
            Next Appointment
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'price' ? 'active' : ''}`} onClick={handleSort('price')}>
            bCARE
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          {eventClick === 'month' && <th className={`cursorPointer ${column === 'dateOfService' ? 'active' : ''}`} onClick={handleSort('dateOfService')}>
            Date Of Service
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>}
        </tr>
      );
    }
  }

  const getTableRows = (detailsModal, reportData, eventClick) => {
    let returnArray = [];
    let totalPrice = 0;
    let uniKey = 0;
    const sortData = sortByDate(data, 'dateOfService');
    if (detailsModal === 'report') {
      if (Object.keys(sortData).length) {
        sortData.forEach((item) => {
          totalPrice += (item.bCare || item.price);
          uniKey++;
          returnArray.push(
            <tr key={uniKey}>
              <td>{getPracticeName(item.Practice)}</td>
              <td>{item.PatNum}</td>
              <td>{formatCurrency(item.bCare ? item.bCare : item.price)}</td>
              {eventClick === 'month' && <td>{item.ProcDate}</td>}
            </tr>
          );
        });

        returnArray.push(
          <tr key={"total"}>
            <td colSpan="2"><strong>Total</strong></td>
            <td colSpan="2"><strong>{formatCurrency(forcedTotal != null ? forcedTotal : totalPrice)}</strong></td>
          </tr>
        );
        return <tbody>{returnArray}</tbody>
      } else {
        return (
          <tbody>
            <tr>
              <td colSpan="4">No Record Found</td>
            </tr>
          </tbody>
        );
      }
    } else {
      if (Object.keys(sortData).length) {
        sortData.forEach((item) => {
          const trimmedString = trimString(item.procCode, 15, false);
          uniKey++;
          totalPrice += (item.bCare ? item.bCare : item.price);
          returnArray.push(
            <tr key={uniKey}>
              <td>{page === 'bGoal' ? item.drName : (item.practiceName || item.practice)}</td>
              <td>{item.patientId}</td>
              <td>{item.age}</td>
              <td>{item.insurance}</td>
              <td className='cursorPointer' title={item.procCode}>{trimmedString}</td>
              <td>{item.Next_Apt}</td>
              <td>{formatCurrency(item.bCare ? item.bCare : item.price)}</td>
              {eventClick === 'month' && <td>{item.dateOfService}</td>}
            </tr>
          );
        });
        returnArray.push(
          <tr key={"total"}>
            <td colSpan="6"><strong>Total</strong></td>
            <td colSpan="2"><strong>{formatCurrency(totalPrice)}</strong></td>
          </tr>
        );
        return <tbody>{returnArray}</tbody>
      } else {
        return (
          <tbody>
            <tr>
              <td colSpan="8">No Record Found</td>
            </tr>
          </tbody>
        );
      }
    }
  }

  return (
    <table className="table table-striped table-hover my-0 TableHeaderFixed">
      <thead>
        {getHeader(detailsModal, eventClick)}
      </thead>
      {reportData && getTableRows(detailsModal, reportData, eventClick)}
    </table>
  );
}

export default ProductionTableData;
